import {
    GET_SITES_CUSTOMER,
    SET_SELECTED_SITE,
} from './customerSiteConstants';
import { setValue } from '../../lib/immutable_wrapper'

const initialState = {
    sites: [],
    selectedSite: null,
}

export function sites(state = initialState, action) {
    switch (action.type) {
        case GET_SITES_CUSTOMER:
            return setValue(state, ['sites'], action.sites);
        case SET_SELECTED_SITE:
            return setValue(state, ['selectedSite'], action.selectedSite);
        default:
            return state;
    }
}
